import ucFirst from '../../../utils/ucFirst';
/**
 * Calculate start and end times strings for display
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {string} _start
 * @param {string} _end
 * @returns {string}
 */
const calcOpenStatus = (_start, _end) => {
  let start,
    end = null;
  if (!_start || !_end) return '';
  const now = new Date().getTime();
  start = new Date(_start).getTime();
  end = new Date(_end).getTime();
  if (now > start && now < end) return 'open';
  //if (start > now && end > now) return 'upcoming';
  else if (now > end) return 'closed';
};

/**
 * Compose and transform peer support items from definitions
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {array} items
 * @returns {array}
 */
const composeCardPeer = (items) => {
  let composed = [];
  items.forEach((i) => {
    composed.push({
      id: i?.id,
      alt: i?.alt,
      heading: i?.heading,
      summary: i?.summary,
      url: i?.url,
      location: i?.location?.length > 1 ? 'Multiple locations' : i?.location[0]?.trim(),
      timeHeading: i?.timeHeading,
      openDate: i?.openDate,
      openStatus: calcOpenStatus(i?.openDate, i?.closeDate),
    });
  });

  return composed;
};

export default composeCardPeer;
